/**
 * Đội ngũ bác sĩ
 */

export default function Doctors() {
    const selectors = {
        'wrapper' : '.js-doctors-wrapper',
        'form' : '.js-filter-doctors-form',
        'result' : '.js-doctors-results',
        'pagination' : '.js-doctors-pagination',
        'city' : '.js-doctor-city',
        'department' : '.js-doctor-department',
    };

    this.init = () => {
        let $form = jQuery(selectors.form);
        if (!$form.length) return;
        this.handleForm();
        this.handlePagination();
        this.handleUI();
    }

    this.template = () => {
        let compiled = null;
        compiled = _.template(
            '<div class="doctor relative"><a href="<%= url %>" title="<%= name %>">\n' +
            '                            <div class="doctor-wrapper relative mx-2">\n' +
            '                                <div class="background absolute bottom-0 left-0 w-full bg-no-repeat bg-cover rounded-20px h-222px shadow-testimonial transition-all duration-400"></div>\n' +
            '                                <div class="author relative z-1 left-0 -bottom-22px  cursor-pointer">\n' +
            '                                    <img class="author-image w-180px h-264px object-contain object-bottom bottom-22px relative" src="<%= image_url %>" alt="<%= name %>"/>\n' +
            '                                    <div class="info absolute bottom-0 -left-7px flex flex-col items-justified space-between bg-white p-4 w-240px h-108px rounded-tr-80px rounded-br-80px shadow-doctor-badge">\n' +
            '                                        <div class="name text-black text-lg leading-tight font-medium mb-2 duration-400 transition-colors"><%= name %></div>\n' +
            '                                        <div class="job text-gray-600 text-xs leading-tight font-normal duration-400 transition-colors"><%= designation %><br /><%= hospital.name %></div>\n' +
            '                                    </div>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                        </a></div>');

        return compiled;
    }

    this.handleUI = function () {
        jQuery(selectors.city).on('select2:select', (e) => {
            let select = jQuery(selectors.department);

            select.find(`.${e.params.data.id}`).prop('disabled', false)
            select.find(`:not(.${e.params.data.id})`).prop('disabled', true)

            let placeholder = select.find('option[value=""]').text();
            let dropdownParent = select.data("dropdown-parent");
            let width = select.data("width");

            let args = {
                placeholder: typeof placeholder != 'undefined' && placeholder.length ? placeholder : '',
            }
            if(typeof dropdownParent != "undefined") {
                args.dropdownParent = jQuery(dropdownParent);
            }
            if(typeof width != "undefined") {
                args.width = width;
            }

            select.select2(args);
            select.val(null).trigger('change')
        })
    }

    this.getDoctors = async (search, city, department, expertise, paged = 1) => {
        return jQuery.ajax({
            type : "GET",
            dataType : "JSON",
            url : theme_object.endpoint_url + 'doctors',
            data : {
                q: search,
                city: city,
                department: department,
                expertise: expertise,
                paged: paged,
            },
            context: this
        })
    }

    this.handleForm = async () => {
        jQuery(selectors.form).on('submit', async (e) => {
            e.preventDefault();

            let $this = jQuery(e.target);
            $this.find('[name="paged"]').val(1)
            this.display($this);

            return false;
        })
    }

    this.display = async ($form) => {
        let search = $form.find('[name="search"]').val();
        let city = $form.find('[name="city"]').val();
        let department = $form.find('[name="department"]').val();
        let expertise = $form.find('[name="expertise"]').val();
        let paged = parseInt($form.find('[name="paged"]').val());
        let wrapper = jQuery(selectors.wrapper);
        if(
            !city.length
            && !department.length
            && !expertise.length
            && !search.length
        ) {
            wrapper.find(selectors.result).empty();
            return;
        }

        wrapper.find('.js-overlay').css({"display":"flex"});
        await this.getDoctors(search, city, department, expertise, paged).then( (res) => {
            if (res.data) {
                let itemTemplate = this.template();
                let resultsDom = jQuery(selectors.wrapper).find(selectors.result);
                resultsDom.empty();

                for(let i in res.data) {
                    let item_data = res.data[i];
                    resultsDom.append(itemTemplate(item_data));
                }
            }

            if (res.meta) {
                $form.find('[name="paged"]').val(res.meta.current_page)
                $form.find('[name="total_pages"]').val(res.meta.total_pages)
                jQuery(selectors.pagination).html(this.pagination(res.meta.current_page, res.meta.total_pages))
            }

            wrapper.find('.js-overlay').hide();
        })
    }

    this.handlePagination = () => {
        jQuery(selectors.pagination).on('click', 'a[data-page]', (e) => {
            e.preventDefault();
            let $this = jQuery(e.currentTarget);
            let $form = jQuery(selectors.form);
            let paged = $this.attr('data-page');
            $form.find('[name="paged"]').val(parseInt(paged))
            this.display($form);
        })
    }

    this.handleForm = async () => {
        jQuery(selectors.form).on('submit', async (e) => {
            e.preventDefault();

            let $this = jQuery(e.target);
            $this.find('[name="paged"]').val(1)
            this.display($this);

            return false;
        })
    }

    this.pagination = (currentPage, totalPages) => {
        if (totalPages == 1) return '';

        let paginationHTML = '';
        let display;
        let next = '<svg fill=none height=14 viewBox="0 0 8 14"width=8 xmlns=http://www.w3.org/2000/svg><path d="M1.01341 1L7 7L1.01341 13"stroke=#4D5761 stroke-linecap=round /></svg>'
        let prev = '<svg fill=none height=14 viewBox="0 0 8 14"width=8 xmlns=http://www.w3.org/2000/svg><path d="M6.98659 1L1 7L6.98659 13"stroke=#4D5761 stroke-linecap=round /></svg>'
        // Previous button
        if (currentPage > 1) {
            paginationHTML += `<a href="#" data-page="${currentPage - 1}" class="prev md:mr-10">${prev}</a>`;
        }

        // First page
        if (currentPage > 2) {
            paginationHTML += `<a href="#" data-page="1" class="text-lg text-gray-600 leading-tight font-light">01</a>`;
        }

        // Ellipsis before current page range
        if (currentPage > 3) {
            paginationHTML += `<span class="dots text-lg text-gray-600 leading-tight font-light">...</span>`;
        }

        // Page numbers around the current page
        let startPage = Math.max(1, currentPage - 1);
        let endPage = Math.min(totalPages, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
            display = i;
            if(i<10 && i > 0) {
                display = '0'+i;
            }
            if (i === currentPage) {
                paginationHTML += `<span class="active text-lg text-primary leading-tight font-medium">${display}</span>`;
            } else {
                paginationHTML += `<a href="#" data-page="${i}" class="text-lg text-gray-600 leading-tight font-light">${display}</a>`;
            }
        }

        // Ellipsis after current page range
        if (currentPage < totalPages - 2) {
            paginationHTML += `<span class="dots text-lg text-gray-600 leading-tight font-light">...</span>`;
        }

        // Last page
        if (currentPage < totalPages - 1) {
            display = totalPages;
            if(totalPages < 10 && totalPages > 0) {
                display = '0'+totalPages;
            }
            paginationHTML += `<a href="#" data-page="${totalPages}" class="text-lg text-gray-600 leading-tight font-light">${display}</a>`;
        }

        // Next button
        if (currentPage < totalPages) {
            paginationHTML += `<a href="#" data-page="${currentPage + 1}" class="next md:ml-10">${next}</a>`;
        }

        return paginationHTML;
    }

}
